export default __webpack_public_path__ + "media/images/search-button-e3df042bc27f515fe747a95b22123dc7.svg";